export const INPUT_OTP = "input_otp";
export const BU_DETAILS = 'bu_details';